import { Link } from "react-router-dom";

const BreadcrumbTrail = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="mb-5 flex flex-wrap items-center gap-2 font-mono text-[0.68rem] uppercase tracking-widest text-[#0a0a0a]"
    >
      <Link to="/" className="hover:text-white">
        Início
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${item.href || index}`} className="inline-flex items-center gap-2">
          <span aria-hidden="true">/</span>
          {item.href ? (
            <Link to={item.href} className="hover:text-white">
              {item.label}
            </Link>
          ) : (
            <span aria-current="page">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default BreadcrumbTrail;
